import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { HttpUtilService } from "../http-util.service";

@Injectable({
  providedIn: "root",
})
export class AccessoryService {

  constructor(private http: HttpUtilService) {}

  /** Gets all accessories. */
  getAll(): Observable<any> {
    return this.http.get('/AccessoryManagerService.asmx/GetAll');
  }

  /** Gets an accessory detail by ID. */
  getDetail(id: string): Observable<any> {
    return this.http.get('/AccessoryManagerService.asmx/GetDetail', {
      params: { id },
    });
  }

  /** Saves accessory details for both Create and Update. */
  saveDetails(data: any): Observable<any> {
    return this.http.post('/AccessoryManagerService.asmx/SaveDetails', { data });
  }

  /** Deletes the selected accessories. */
   delete(items: any[]): Observable<any> {
    return this.http.post('/AccessoryManagerService.asmx/Delete', { items });
  }
}
